import React from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  CardActionArea,
  useTheme
} from '@mui/material';
import {
  People as PeopleIcon,
  Event as EventIcon,
  Business as BusinessIcon,
  Assessment as AssessmentIcon,
  Description as ReportIcon,
  LocalShipping as TransportationIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const cards = [
    {
      title: 'Providers',
      description: 'Manage provider information and accounts',
      icon: <BusinessIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />,
      path: '/providers'
    },
    {
      title: 'Clients',
      description: 'Manage your client records',
      icon: <PeopleIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />,
      path: '/clients'
    },
    {
      title: 'Client ISP',
      description: 'Manage Individual Service Plans, outcomes, experiences, and supports',
      icon: <AssessmentIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />,
      path: '/isp'
    },
    {
      title: 'Visits',
      description: 'Create and manage visits',
      icon: <EventIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />,
      path: '/visits'
    },
    {
      title: 'Transportation',
      description: 'View and manage transportation records',
      icon: <TransportationIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />,
      path: '/transportation'
    },
    {
      title: 'Compliance Reporting',
      description: 'Generate compliance reports and official monthly documentation PDFs',
      icon: <ReportIcon sx={{ fontSize: 48, color: theme.palette.primary.main }} />,
      path: '/compliance-reporting'
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Welcome to EasyIP Admin Portal
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Select a section below to get started
        </Typography>
      </Paper>

      <Grid container spacing={3}>
        {cards.map((card) => (
          <Grid item xs={12} sm={6} md={4} key={card.title}>
            <Card 
              sx={{ 
                height: '100%',
                backgroundColor: '#ffffff',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'scale(1.02)',
                }
              }}
            >
              <CardActionArea 
                onClick={() => navigate(card.path)}
                sx={{ height: '100%' }}
              >
                <CardContent sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center',
                  textAlign: 'center',
                  p: 3
                }}>
                  {card.icon}
                  <Typography variant="h6" component="div" sx={{ mt: 2 }}>
                    {card.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {card.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Home; 